import React from "react";
import { Checkbox } from "antd";
import Text from "../../common/typography/text";

const groupDefs = (defs) => {
  const modules = new Map();
  defs.forEach((def) => {
    if (!modules.has(def.module)) modules.set(def.module, new Map());
    const categories = modules.get(def.module);
    if (!categories.has(def.category)) categories.set(def.category, []);
    categories.get(def.category).push(def);
  });
  return modules;
};

const PermissionEditor = ({ defs, values, onToggle, disabled }) => {
  const grouped = React.useMemo(() => groupDefs(defs), [defs]);

  if (defs.length === 0) {
    return null;
  }

  return (
    <div className="permission-editor-grid">
      {[...grouped.entries()].map(([moduleName, categories]) => (
        <div className="permission-editor-module" key={moduleName}>
          <Text variant="bodyText" className="permission-editor-module-title">
            {moduleName}
          </Text>
          {[...categories.entries()].map(([categoryName, categoryDefs]) => (
            <div className="permission-editor-category" key={categoryName}>
              <Text variant="smallText" color="lightText">
                {categoryName}
              </Text>
              <div className="permission-editor-chip-row">
                {categoryDefs.map((def) => {
                  const parentSatisfied = def.dependsOn
                    ? Boolean(values[def.dependsOn])
                    : true;
                  const isDisabled = disabled || !parentSatisfied;
                  return (
                    <label
                      key={def.key}
                      className={`permission-editor-chip${
                        isDisabled ? " permission-editor-chip-disabled" : ""
                      }`}
                    >
                      <Checkbox
                        checked={Boolean(values[def.key])}
                        disabled={isDisabled}
                        onChange={(e) => onToggle(def.key, e.target.checked)}
                      />
                      <span>{def.label}</span>
                    </label>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default PermissionEditor;
